import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from '../components/constant/BaseUrl'

export const myApi = createApi({
  reducerPath: "myApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: async (headers) => {
      const token = await localStorage.getItem('jwtToken')
      if (!!token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
    fetchFn: async (input, init, ...rest) => {
      const response = await fetch(input, init, ...rest);

      if (response.status === 401) {
        localStorage.removeItem("jwtToken"); // Remove token from localStorage
        window.location.href = "/"; // Redirect to login page
      }

      return response;
    }
  }),

  tagTypes: ["user", "record", "usersendminamount", "toprankdate", "youtubeUrl", "liveTokenDate", "transaction", "instaurl", "cookietext", "presalestatus"],
  endpoints: (builder) => ({
  }),

})